//@ts-nocheck
import { createSelector } from 'reselect'
import { Shared } from 'types/Shared'
import { getShared } from './helpers'

export const getFeatureFlags = createSelector(
  [getShared],
  (shared: Shared): Shared['featureFlags'] => shared.featureFlags || {}
)
